import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import { HeroIcon } from "@/components/hero-icon";
import { Button } from "@/components/ui/button";

type ErrorBannerProps = {
  title?: string;
  message?: string;
  refetch?: () => void;
};

export const ErrorBanner = ({
  title: titleProp,
  message: messageProp,
  refetch,
}: ErrorBannerProps) => {
  const t = useTranslations("instructions");
  const tc = useTranslations("common");
  const title = titleProp ?? t("errorTitle");
  const message = messageProp ?? t("errorMessage");
  return (
    <motion.div
      initial={{ opacity: 0, transform: "translateY(-24px)" }}
      animate={{ opacity: 1, transform: "translateY(0px)" }}
      exit={{ opacity: 1, transform: "translateY(-24px)" }}
      transition={{ type: "spring", duration: 0.16, mass: 0.2 }}
      className="flex flex-col items-center space-y-2 rounded-lg border border-red-400/20 bg-red-400/20 p-4"
    >
      <div className="flex flex-1 flex-row items-center">
        <HeroIcon
          name="exclamation-circle"
          className="mr-2 h-9 w-9 shrink-0 text-destructive"
        />
        <div>
          <p className="font-bold text-red-950 text-sm">{title}</p>
          <p className="text-red-950 text-sm">{message}</p>
        </div>
      </div>
      {refetch && (
        <div className="ml-10 shrink-0 self-start">
          <Button
            className="cursor-pointer rounded-lg bg-red-500 text-white hover:bg-red-600"
            onClick={() => refetch()}
          >
            {tc("retry")}
          </Button>
        </div>
      )}
    </motion.div>
  );
};
